<template>

  <router-link v-if="chat.lastUpdated >= after" :class="{ 'chat-item': true, 'multiple': (members.length > 2), 'notify': (unreads['.value'] > 0) }" :to="'/chats/' + id">
    <div v-on:click="read">
      <div class="image-holder" v-if="members.length > 2">
        <profile-picture v-for="(member, id) in members" :member="member['.key']" :key="member['.key']" :index="id" v-if="id < 4" :total="members.length"></profile-picture>
      </div>
      <div v-else>
        <profile-picture v-for="(member, id) in members" v-if="member['.key'] !== $root.user.uid" :member="member['.key']" :key="member['.key']"></profile-picture>
      </div>
      <div class="info">
        <h5 v-if="members.length > 2">
          <first-name-list v-for="(member, id) in members" :member="member['.key']" :deli="','" :showDeli="(id + 1 < members.length)" :key="member['.key']"></first-name-list>
        </h5>
        <h5 v-else>
          <full-name-list v-for="(member, id) in members" v-if="member['.key'] !== $root.user.uid" :member="member['.key']" :key="member['.key']"></full-name-list>
        </h5>
        <span v-if="unreads['.value'] > 0" class="notification">{{ unreads['.value'] }}</span>
        <span style="color: #000;">{{ dateFormat(chat.lastUpdated, 'h:MMtt') }}</span>
        <p>{{ chat.lastMessage }}</p>
      </div>
    </div>
  </router-link>

</template>

<script>
import { db } from '@/firebase'
import FullNameList from '@/components/chat/naming/FullNameList'
import FirstNameList from '@/components/chat/naming/FirstNameList'
import ProfilePicture from '@/components/chat/list/ProfilePicture'
var dateFormat = require('dateformat')

export default {
  name: 'Item',
  props: ['id', 'after'],
  data () {
    return {
      dateFormat: dateFormat,
      chat: {
        lastMessage: null,
        lastUpdated: null
      },
      unreads: 0
    }
  },
  components: {
    FullNameList,
    FirstNameList,
    ProfilePicture
  },
  firebase () {
    return {
      chat: {
        source: db.ref('chats/' + this.id),
        asObject: true
      },
      unreads: {
        source: db.ref('chats/' + this.id + '/unreads/' + this.$root.user.uid),
        asObject: true
      },
      members: db.ref('chats-members/' + this.id)
    }
  },
  methods: {
    read () {
      // db.ref('chats/' + this.id + '/unreads/' + this.$root.user.uid).set(0)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Item.vue?b3646b60